export const deClientPortalRatingChip = {}
